import styled from 'styled-components';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';

export const BlockVariation = styled(Block)`
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
`;
